import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import HomeScreen from './src/screens/HomeScreen';
import PopUp from './src/screens/PopUp';
import Cart from './src/components/Cart';
import rootReducer from './Redux/reducers';
import Delivery from './src/screens/Delivery'


const store = configureStore({
  reducer: rootReducer, // Pass the root reducer to configureStore
});

const Stack = createNativeStackNavigator();

export default function App() {
  return (
    <Provider store={store}>
      <NavigationContainer>
        <Stack.Navigator>
          <Stack.Screen name="Home" component={HomeScreen} />
          <Stack.Screen name="Popup" component={PopUp} />
          <Stack.Screen name="Cart" component={Cart} />
          <Stack.Screen name="OrderNow" component={Delivery} />
        </Stack.Navigator>
      </NavigationContainer>
    </Provider>
  );
}
